import React, { useState, useEffect, useContext } from 'react';
import { Box, Card, CardContent, CardMedia, Typography, Link, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DialogSeeMoreRoomType from './DialogSeeMoreRoomType';
import RatePlanDetail from './DialogDetailRatePlan';
import {
  obtenerMuestroTiposHabitacion, obtenerMuestroTarifaTipoHab,
  obtenerServiciosDeHabitacion, obtenerMuestroCarrito,
} from '../../services/motorService';
import { roomServices } from '../roomServices/RoomServices';
import RoomTypeRatePlanContext from '../contexts/RoomTypeRatePlanContext';
import useSession from '../../services/session';
import RoomsContext from '../contexts/RoomsContext';
import { grabarCarrito } from '../../services/motorService';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
import LinearProgress from '@mui/material/LinearProgress';

function RoomTypeRatePlan() {
  const { selectedDetails, cartItems, setCartItems } = useContext(RoomTypeRatePlanContext);
  const { rooms, updateRoom } = useContext(RoomsContext);
  const [roomTypeList, setRoomTypeList] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [ratePlanDialogOpen, setRatePlanDialogOpen] = useState(false);
  const [selectedRatePlan, setSelectedRatePlan] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [isSelecting, setIsSelecting] = useState(false); // Estado para manejar la selección
  const hotCod = Cookies.get('hotCod');
  const sesion = useSession();
  const [isLoading, setIsLoading] = useState(false); 
  const [timeoutId, setTimeoutId] = useState(null); 

  useEffect(() => {
    const fetchRoomTypes = async () => {
        setIsLoading(true); // Activar el loader al iniciar la búsqueda

        const timer = setTimeout(() => {
            setIsLoading(false); // Ocultar el loader después de 10 segundos
            setRoomTypeList([]); // Si no se encontraron habitaciones, vaciar la lista
        }, 10000); // Tiempo límite de 10 segundos
        setTimeoutId(timer);

        try {
            //console.log("Carrito:", cartItems); 
            const response = await obtenerMuestroTiposHabitacion(hotCod, selectedDetails.startDate.toISOString().split('T')[0], selectedDetails.endDate.toISOString().split('T')[0]);
            //console.log("TIPOS DE HABITACION: ", response);
            const roomTypes = await Promise.all(response.map(async (room) => {
                const ratePlans = await obtenerMuestroTarifaTipoHab(hotCod, room.TipoHabCodigo, selectedDetails.startDate.toISOString().split('T')[0]);
                
                const ratePlansWithPrices = Array.isArray(ratePlans) 
                    ? await Promise.all(ratePlans.map(async (ratePlan) => {
                        const lowestPrice = await getLowestPriceFromRatePlans(
                            room.TipoHabCodigo, 
                            selectedDetails.startDate, 
                            selectedDetails.endDate, 
                            ratePlan.TarifaCodAdm
                        );
                        return {
                            ratePlan,
                            lowestPrice,
                        };
                    }))
                    : []; 

                const services = await obtenerServiciosDeHabitacion(hotCod, room.TipoHabCodigo);
                const mappedServices = Array.isArray(services) && services.length > 0
                    ? services.map(service => {
                        const matchedService = roomServices.find(rs => rs.service === service.ServTipoHabIdentificador);
                        return matchedService 
                            ? { icon: matchedService.icon, description: service.ServTipoHabNombre }
                            : null;
                    }).filter(Boolean)
                    : [];

                return {
                    roomType: room.TipoHabNombre,
                    description1: room.TipoHabTexto1,
                    description2: room.TipoHabTexto2,
                    description3: room.TipoHabTexto3,
                    image: room.TipoHabFotoTxt,
                    quantity: room.TipoHabQuedan,
                    ratePlans: ratePlansWithPrices,
                    services: mappedServices,
                    roomTypeCode: room.TarifaCodAdm,
                    maxCapacity: room.TipoHabCupoMax,
                };
            }));
            //console.log("lista de roomtype:", roomTypes);
            
            const filteredRoomTypes = roomTypes.filter((roomType) => {
              //console.log("roomType cuando estoy filtrando;", roomType);
              console.log("TODOS LOS ROOMS SELECCIONADOS:", rooms);
              const nextAvailableRoom = rooms.find((room) => !room.isInCart);
              console.log("A VER A QUE ROOM HACE REFERENCIA",nextAvailableRoom);
              if(!nextAvailableRoom){
                console.log("NO HAY HABITACIONES DISPONIBLES");
                return;
              }
              const totalPeople = nextAvailableRoom.adultsCount + nextAvailableRoom.childrenCount;
              console.log("TOTAL DE PAX;", totalPeople);
              return (
                  roomType.quantity > 0 &&
                  roomType.maxCapacity >= totalPeople &&
                  Array.isArray(roomType.ratePlans) &&
                  roomType.ratePlans.length > 0
              );
          });



            //console.log("Los rooms filtrados:", filteredRoomTypes);
            clearTimeout(timer); // Cancelar el temporizador si la búsqueda se completa antes de 10 segundos
            setIsLoading(false); // Ocultar el loader
            setRoomTypeList(filteredRoomTypes);
        } catch (error) {
            setIsLoading(false);
            console.error('Error fetching room types data:', error);
        }
    };

    fetchRoomTypes(); // Llamar la primera vez para cargar los datos iniciales

  }, [selectedDetails, cartItems, rooms]);

  /*useEffect(() => {
    const handleFocus = () => {
      // Refrescar datos cuando la ventana vuelve a estar activa
      fetchCart();
    };
    window.addEventListener('focus', handleFocus);
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, []);*/

  const handleClickOpen = (room) => {
    setSelectedRoom(room);
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleRatePlanClickOpen = (ratePlan, room) => {
    setSelectedRatePlan(ratePlan, room);
    setRatePlanDialogOpen(true);
  };

  const handleRatePlanClose = () => {
    setRatePlanDialogOpen(false);
  };

  const handleSelect = async (roomType, ratePlan) => {
    if (isSelecting) return;
    setIsSelecting(true); 

    try {
      const cart = await obtenerMuestroCarrito(hotCod, sesion);
      var selectedRoomsCount = 0;
      if (cart != null)
        selectedRoomsCount = cart.length;
      if (selectedRoomsCount >= rooms.length) {
        setAlertOpen(true);
        return;
      }

      const nextAvailableRoom = rooms.find((room) => !room.isInCart);


      //const selectedRoom = rooms[selectedRoomsCount];
      const totalAdults = nextAvailableRoom.adultsCount;
      const totalChildren = nextAvailableRoom.childrenCount;
      console.log("********************************************");
      console.log("********************************************");
      console.log("ROOM SELECCIONADO:", nextAvailableRoom);
      console.log("********************************************");
      console.log("********************************************");
      const carrito = {
        hotelcarrito: hotCod,
        Sesion: sesion,
        DesdeFecha: selectedDetails.startDate,
        hastafecha: selectedDetails.endDate,
        mayores: totalAdults,
        menores: totalChildren,
        TipoHab: ratePlan.TarifaTipoHab,
        tarifa: parseInt(ratePlan.TarifaCodAdm),
      };
      await grabarCarrito(carrito);
      const updatedCart = await obtenerMuestroCarrito(hotCod, sesion);
      setCartItems(updatedCart);
      //await grabarCarrito(carrito);
      await fetchCart();
      if(!cart){
        console.log("********************************************");
        console.log("********************************************");
        console.log("CARRITO VACIO, AGREGUE EL 1ER ELEMENTO");
        console.log("********************************************");
        console.log("********************************************");
        updateRoom(1, true);
      }else{
        console.log("********************************************");
        console.log("********************************************");
        console.log("LARGO CARRITO:", cart.length);
        console.log("********************************************");
        console.log("********************************************");
        updateRoom(cart.length+1, true);

      }

      

    } catch (error) {
      console.error('Error updating and fetching cart data:', error);
    } finally {
      setIsSelecting(false); // Permitir nuevamente la selección
    }
  };

  const fetchCart = async () => {
    try {
      const cart = await obtenerMuestroCarrito(hotCod, sesion);
      if (cart && cart.length > 0) {
        setCartItems(cart);
        
      } else {
        setCartItems([]);
      }
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  };

  const getLowestPriceFromRatePlans = async (tipoHabCodigo, startDate, endDate, tarifaCodAdm) => {
    let lowestPrice = null;

    let currentDate = new Date(startDate);
    while (currentDate <= new Date(endDate)) {
        const formattedDate = currentDate.toISOString().split('T')[0];
        const ratePlans = await obtenerMuestroTarifaTipoHab(hotCod, tipoHabCodigo, formattedDate);

        if (ratePlans && ratePlans.length > 0) {
            // Filtra los planes de tarifas por tarifaCodAdm
            const matchingRatePlan = ratePlans.find(ratePlan => ratePlan.TarifaCodAdm === tarifaCodAdm);
            if (matchingRatePlan) {
                const currentRate = matchingRatePlan.TarifaPrecioDesde;
                if (lowestPrice === null || currentRate < lowestPrice) {
                    lowestPrice = currentRate;
                }
            }
        }

        currentDate.setDate(currentDate.getDate() + 1);
    }

    return lowestPrice;
};

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  return (
    <div>
      {isLoading ? (
        <Typography variant="h6" component="div" color="text.secondary" sx={{ textAlign: 'center', mt: 4 }}>
          Buscando habitaciones disponibles para el período seleccionado...
          <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
        </Typography>
      ) : cartItems.length >= rooms.length ? (
        <Typography variant="h6" component="div" color="text.secondary" sx={{ textAlign: 'center', mt: 4 }}>
          Todas las habitaciones necesarias han sido seleccionadas.
        </Typography>
      ) : roomTypeList.length === 0 ? (
        <Typography variant="h6" component="div" color="text.secondary" sx={{ textAlign: 'center', mt: 4 }}>
          No hay habitaciones disponibles para la habitación actual.
        </Typography>
      ) : (
        <>
          {/* Mostrar información sobre la habitación que se está seleccionando */}
          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant="h6" component="div" color="text.primary">
              Seleccionando la habitación {cartItems.length + 1}
            </Typography>
          </Box>

          {/* Mostrar las habitaciones filtradas */}
          {roomTypeList.map((roomType, index) => (
            <Box key={index} sx={{ mb: 4 }} className="boxRoomType">
              <Card sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }} className="boxRoomType">
                <CardMedia
                  component="img"
                  sx={{ width: { xs: '100%', md: 392 }, height: 200 }}
                  image={`data:image/png;base64,${roomType.image}`}
                  alt="Room Name"
                />
                <CardContent sx={{ flex: '1 0 auto', spacing: 3 }} className="boxRoomType">
                  <Typography variant="h5" component="div">
                    {roomType.roomType}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" component="div">
                    {roomType.description1}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" component="div">
                    {roomType.description2}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" component="div">
                    {roomType.description3}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" component="div">
                    {Array.isArray(roomType.services) &&
                      roomType.services.length > 0 &&
                      roomType.services.map((service, index) =>
                        service ? (
                          <span key={index} style={{ fontSize: '20px', marginRight: '8px' }}
>
                            {service.icon}
                          </span>
                        ) : null
                      )}
                  </Typography>
                  <Link href="#" color="#007289" onClick={() => handleClickOpen(roomType)}>
                    Ver más
                  </Link>
                </CardContent>
              </Card>
              <div>
                {roomType.ratePlans &&
                  roomType.ratePlans.map((ratePlan, rateIndex) => (
                    <Card
                      key={rateIndex}
                      sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' } }}
                      className="cardRate"
                    >
                      <CardContent sx={{ flex: '1 0 auto', spacing: 3 }} className="cardRate">
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Typography variant="subtitle1" color="text.secondary" component="div">
                            {ratePlan.ratePlan.TarifaDescripcion}
                          </Typography>
                          {roomType.quantity < 5 && (
                            <Chip
                              variant="outlined"
                              color="error"
                              size="small"
                              label={`Solo queda${roomType.quantity === 1 ? '' : 'n'} ${roomType.quantity}`}
                              sx={{ ml: 1 }}
                            />
                          )}
                        </Box>
                        <Link href="#" variant="body2" color="#007289" onClick={() => handleRatePlanClickOpen(ratePlan)}>
                          Detalle de la tarifa
                        </Link>
                      </CardContent>
                      <CardContent
                        sx={{ flex: '1 0 auto', spacing: 3, textAlign: { xs: 'left', md: 'right' } }}
                        className="cardRate"
                      >
                        <Typography variant="subtitle1" color="text.secondary" component="div">
                          desde {ratePlan.ratePlan.TarifaMonDsc}{' '}
                          {parseFloat(ratePlan.lowestPrice).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                          /noche
                        </Typography>
                        <Button
                          variant="contained"
                          onClick={async () => await handleSelect(roomType, ratePlan.ratePlan)}
                          onTouchEnd={async () => await handleSelect(roomType, ratePlan.ratePlan)}
                          disabled={isSelecting} // Deshabilitar el botón mientras se procesa la selección
                        >
                          Seleccionar
                        </Button>
                      </CardContent>
                    </Card>
                  ))}
              </div>
            </Box>
          ))}
        </>
      )}
      <DialogSeeMoreRoomType open={dialogOpen} handleClose={handleClose} room={selectedRoom} />
            <RatePlanDetail
              open={ratePlanDialogOpen}
              handleClose={handleRatePlanClose}
              ratePlan={selectedRatePlan}
              selectedRange={selectedDetails}
              room={selectedRoom}
            />
            <Dialog
              open={alertOpen}
              onClose={handleAlertClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Límite de habitaciones alcanzado"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  No puedes seleccionar más habitaciones de las que se han especificado.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleAlertClose} color="primary" autoFocus>
                  Aceptar
                </Button>
              </DialogActions>
            </Dialog>
    </div>
  );
}

export default RoomTypeRatePlan;